import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import anime from "animejs";

const Container = styled.div`
  .bar {
    width: 0%;
    height: ${props => props.height}px;
    background-color: ${props => props.color};
  }
`;

export default class LoadingSlider extends PureComponent {
  static propTypes = {
    onComplete: PropTypes.func,
    height: PropTypes.number,
    color: PropTypes.string,
    duration: PropTypes.number
  };
  static defaultProps = {
    onComplete: () => null,
    height: 5,
    color: "lightgrey",
    duration: 5000
  };
  constructor(props) {
    super(props);
    this.barRef = React.createRef();
  }
  componentDidMount = () => {
    const { duration } = this.props;
    this.animateBar = anime({
      targets: this.barRef.current,
      easing: "linear",
      duration: duration,
      width: "100%",
      loop: true
    });
    this.animateBar.update = anim => {
      if (anim.progress === 100) {
        this.props.onComplete();
      }
    };
  };
  getAnimate = () => this.animateBar;
  render() {
    const { height, color } = this.props;
    return (
      <Container height={height} color={color}>
        <div ref={this.barRef} className="bar" />
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LoadingSlider.js